import { TUseSearchParams } from '@/hooks/use-search-params.ts';
import { XIcon } from 'lucide-react';
import { Button } from '@/components/ui/button.tsx';
import { Badge } from '@/components/ui/badge.tsx';
import { IProductsRes } from '@/types/models.ts';

export function RemoveFilters({ data, useSearch }: { data: IProductsRes; useSearch: TUseSearchParams }) {
  const removeFilter = (key: string, value: any) => {
    if (key === 'wcm') {
      useSearch.setParams({ wcm: undefined, wcm_margin: undefined });
    } else if (key === 'lcm') {
      useSearch.setParams({ lcm: undefined, lcm_margin: undefined });
    } else {
      useSearch.removeValue(key, value);
    }
  }
  return (
    <div className="flex flex-wrap gap-2">
      {(Number(data?.filters?.length || 0) > 0 || String(useSearch.get('q') || '').length > 0) && (
        <Button
          variant="outline"
          size="icon"
          className="h-auto w-auto rounded-full! p-1 px-2"
          onClick={() => useSearch.resetParams()}
        >
          Clear All&nbsp;
          <XIcon className="h-3 w-3" />
          <span className="sr-only">Clear All</span>
        </Button>
      )}
      {data?.filters?.map((filter) => (
        <Badge key={filter.key + '-' + filter.value} className="uppercase pr-1">
          <span>{filter.label}</span>
          <Button
            variant="ghost"
            size="icon"
            className="h-auto w-auto rounded-full! p-1 text-xs"
            onClick={() => removeFilter(filter.key, filter.value)}
          >
            <XIcon className="h-3 w-3" />
            <span className="sr-only">Remove {filter.label}</span>
          </Button>
        </Badge>
      ))}
    </div>
  );
}
